import React from 'react';

import { EMailSuggestionPickerField } from '../../../../../../../../../../components/entity-picker/EMailSuggestionPickerField';
import { ControllerPlus } from '../../../../../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import { ContactMaskFormValue } from '../../../../../types';
import { useContactEmailSuggestions } from '../../../../../use-contact-email-suggestions';

export const Email: React.FC = () => {
  const { setValue, control } = useFormContextPlus<ContactMaskFormValue>();

  const {
    enableEMailSuggestions,
    setEnableEMailSuggestions,
    firstname,
    lastname,
    businessPartnerId,
    businesspartnerType,
  } = useContactEmailSuggestions();

  return (
    <ControllerPlus
      name={'eMail'}
      control={control}
      render={({ field }) => {
        return (
          <EMailSuggestionPickerField
            {...field}
            firstName={firstname}
            businesspartnerType={businesspartnerType}
            lastName={lastname}
            businessPartnerId={businessPartnerId}
            onChange={(value) => {
              setEnableEMailSuggestions(false);
              setValue('eMail', value, { shouldDirty: true });
            }}
            color={enableEMailSuggestions ? 'warning' : undefined}
          />
        );
      }}
    />
  );
};
